import React, { useEffect, useState } from 'react';

import Select from '../Select/Select';
import Label from '../Label/Label';
import Input from '../Input/Input';
import Description from '../Description/Description';

import styles from './TimeField.module.css';

const TimeField = ({ field, changed, disabled, type, color, options }) => {
    const [timeType, setTimeType] = useState({});
    const [timeNumber, setTimeNumber] = useState('');
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        if (isInitialized) {
            return;
        }
        setIsInitialized(true);

        if (!field.value) {
            setTimeType(options[Object.keys(options)[0]]);
            return;
        }

        let selectedOption;
        if (options.HOURS && field.value % options.HOURS.value === 0) {
            selectedOption = options.HOURS;
        } else if (options.MINUTES && field.value % options.MINUTES.value === 0) {
            selectedOption = options.MINUTES;
        } else {
            console.error('Time types options do not fit to the current milliseconds value');
            setTimeType(options[Object.keys(options)[0]]);
            return;
        }
        setTimeType(selectedOption);
        setTimeNumber((field.value / selectedOption.value).toString());
    }, [options, field, setTimeNumber, setTimeType, isInitialized, setIsInitialized]);

    const getOptionByValue = (value) => {
        for (const option in options) {
            if (options[option].value === value) {
                return options[option];
            }
        }
    };

    const onTypeChange = (id, val) => {
        const option = getOptionByValue(val);
        let newTimeNumber = timeNumber;

        if (
            newTimeNumber &&
            ((option.max && parseInt(newTimeNumber) > option.max) ||
                (option.min && parseInt(newTimeNumber) < option.min))
        ) {
            newTimeNumber = '';
        }
        setTimeNumber(newTimeNumber);
        setTimeType(option);
        changed(id, newTimeNumber ? parseInt(timeNumber) * val : undefined);
    };

    const onNumberChange = (id, val) => {
        if (val && timeType.value) {
            changed(id, parseInt(val) * timeType.value);
        } else {
            changed(id);
        }
        setTimeNumber(val);
    };

    return (
        <div className={styles.SelectInput}>
            <Label value={field.name} />
            <div className={styles.fieldsContainer}>
                <div className={styles.numbersContainer}>
                    <Input
                        id={field.id}
                        className={styles.inputField}
                        value={timeNumber}
                        type="number"
                        minNumber={timeType.min ? timeType.min.toString() : '0'}
                        maxNumber={timeType.max ? timeType.max.toString() : undefined}
                        changed={onNumberChange}
                        disabled={disabled}
                        placeholder={timeType.max ? `${timeType.min ? timeType.min : 0}-${timeType.max}` : undefined}
                    />
                </div>
                <div className={styles.typeSelector}>
                    <Select
                        id={field.id}
                        value={timeType.value}
                        options={Object.values(options)}
                        disabled={disabled}
                        type={type}
                        color={color}
                        changed={onTypeChange}
                    />
                </div>
            </div>
            {field.error && <div className={styles.errorText}>{field.error}</div>}
            {field.notification && <div className={styles.notificationText}>{field.notification}</div>}
            {field.desc && <Description value={field.desc} />}
        </div>
    );
};

export default React.memo(TimeField);
